import React from 'react';
import { StyleSheet, ViewProps } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, Image, TouchableBox } from '@/components/lib/components';
import { designSystem, withOpacity } from '@/styles/styles';

type LeagueTileProps = {
    onLayout?: ViewProps['onLayout'];
    isLastItem?: boolean;
    icon?: string | JSX.Element;
    subLabel?: string | JSX.Element;
    onPress?: () => void;
    testID?: string;
    disabled?: boolean;
    selected?: boolean;
    isLive?: boolean;
    label: string;
};

export const LaunchpadTile = ({
    label,
    icon,
    selected,
    onPress,
    disabled,
    isLive,
    onLayout,
    isLastItem,
}: LeagueTileProps) => {
    return (
        <TouchableBox
            paddingLeft="s16"
            paddingRight={isLastItem ? 's16' : 's0'}
            onLayout={onLayout}
            alignItems={'center'}
            onPress={onPress}
            gap={'s8'}
            opacity={disabled ? 0.3 : 1}
            disabled={disabled}
            paddingTop={'s16'}
        >
            {isLive && (
                <Box
                    position={'absolute'}
                    width={10}
                    height={10}
                    backgroundColor={'red500'}
                    borderRadius={'r10'}
                    top={15}
                    zIndex={1}
                    right={0}
                />
            )}
            <Box
                width={44}
                height={44}
                justifyContent={'center'}
                alignItems={'center'}
                backgroundColor={selected ? 'neutral600' : 'neutral800'}
                style={[styles.logoContainer, selected ? styles.selectedLogoContainer : {}]}
                borderWidth={1}
            >
                {typeof icon === 'string' ? (
                    <Image source={{ uri: icon }} style={styles.logo} resizeMode={'contain'} />
                ) : (
                    icon
                )}
            </Box>
            <Text variant="labelLarge" color={selected ? 'white' : 'gray3'}>
                {label}
            </Text>
        </TouchableBox>
    );
};

const styles = StyleSheet.create({
    logo: {
        width: 22,
        height: 22,
    },
    logoContainer: {
        borderRadius: 13,
        borderCurve: 'continuous',
        borderColor: withOpacity(designSystem.colors.white, 0.02),
    },
    selectedLogoContainer: {
        borderColor: withOpacity(designSystem.colors.white, 0.03),
    },
});
